import { GET_CREDIT_LIMIT_START, GET_CREDIT_LIMIT_SUCCESS, GET_CREDIT_LIMIT_FAILURE, RESET_REDUX, RESET_ON_IMPERSONATION } from "../../actions/actionTypes";

const initialState = {
  creditLimit: {
    openCreditLimit : '',
    availableCreditLimit: '',
    usedCreditLimit: '',
    creditBlocked: false,
    dataCollected: false
  },
  loading: false,
  errorMessage: ''
};

const creditLimitReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case GET_CREDIT_LIMIT_START: {
      return {
        ...state,
        loading: true
      }
    }

    case GET_CREDIT_LIMIT_SUCCESS: {
      return {
        ...state,
        loading: false,
        creditLimit: action.payload.creditLimitResponse,
        dataCollected: true
      }
    }

    case GET_CREDIT_LIMIT_FAILURE: {
      return {
        ...state,
        loading: false,
        errorMessage: action.payload.errorMessage,
        dataCollected: true,
      }
    }

    case RESET_REDUX: {
      return {...initialState}
    }

    case RESET_ON_IMPERSONATION: {
      return {...initialState}
    }

    default: {
      return state;
    }
  }
};

export default creditLimitReducer;
